import Button from "./Button";
import SpinnerButton from "./SpinnerButton";

export type FooterButtonProps = {
  onClick?: () => void;
  className?: string;
  children?: React.ReactNode;
  disabled?: boolean;
  spinning?: boolean;
}

const className = (extraNames?: string) => {
  const extra = extraNames ? ` ${extraNames}` : '';
  return `px-5 py-3${extra}`;
}

const FooterButton = (props: FooterButtonProps) =>
  props.spinning
    ? <SpinnerButton className={className(props.className)} spinning={props.spinning} {...props}>
      {props.children}
    </SpinnerButton>
    : <Button className={className(props.className)} disabled={props.disabled} onClick={props.onClick}>
      {props.children}
    </Button>


export default FooterButton;
